export const nav = {
  home: "Home",
  about: "About Us",
  services: "Our Services",
  projects: "Projects",
  expertise: "Expertise",
  contact: "Contact",
  requestConsultation: "Request Consultation"
};

export const hero = {
  title: "Engineering the Future of Renewable Energy",
  subtitle: "with Global Expertise in Solar, Wind & Storage"
};

export const services = {
  sectionLabel: "Our Engineering Capabilities",
  sectionTitle: "Integrated Renewable Energy Engineering Solutions",
  solar: {
    title: "Solar Energy Systems",
    description: "Utility-scale and commercial solar PV engineering services, including feasibility studies, system design, performance modeling, and optimization for energy yield and project economics."
  },
  wind: {
    title: "Wind Power Solutions",
    description: "Advanced wind farm development support, including turbine selection and performance analysis for onshore and offshore projects."
  },
  battery: {
    title: "Battery Storage",
    description: "Energy storage system integration, BESS design, and grid-scale battery solutions to enhance reliability and flexibility."
  },
  grid: {
    title: "Grid Integration",
    description: "Power system studies, grid connection engineering, and compliance solutions for seamless renewable energy integration."
  }
};

export const about = {
  sectionLabel: "ABOUT SALL ENGINEERING",
  sectionTitle: "Global Engineering Excellence in Renewable Energy Solutions",
  paragraph1: "SALL Engineering is the renewable energy engineering and consulting division of SALL Collection Tekstil Sanayi ve Ticaret A.Ş., headquartered in Istanbul, Türkiye. The company delivers advanced technical solutions for solar, wind, and energy storage projects across global markets.",
  noteLabel: "Corporate Note:",
  noteText: "SALL Engineering operates as part of SALL Collection Tekstil Sanayi ve Ticaret A.Ş., a diversified holding company with activities across multiple industries."
};

export const projects = {
  sectionLabel: "FEATURED PROJECTS",
  sectionTitle: "Selected Experience in Renewable Energy Projects",
  solar: {
    category: "Solar Energy",
    title: "Utility-Scale Solar PV — Engineering Support",
    scope: "Scope includes feasibility studies, PV system design, yield modeling, and optimization."
  },
  wind: {
    category: "Wind Power",
    title: "Wind Energy — Resource Assessment & Yield Analysis",
    scope: "Scope includes resource assessment, layout optimization, turbine selection support, and energy yield analysis."
  },
  storage: {
    category: "Energy Storage",
    title: "Battery Energy Storage — Grid Integration & Sizing",
    scope: "Scope includes BESS sizing, grid integration studies, operating scenarios, and performance evaluation."
  }
};

export const expertise = {
  sectionLabel: "TECHNICAL EXPERTISE",
  sectionTitle: "Multidisciplinary Engineering Capabilities",
  description: "Our team brings together specialists in electrical engineering, mechanical design, environmental science, and project management to deliver comprehensive renewable energy solutions that meet the highest technical and regulatory standards.",
  items: {
    powerSystems: {
      title: "Power Systems Analysis",
      description: "Load flow, stability, and fault analysis for complex power networks"
    },
    environmental: {
      title: "Environmental Impact",
      description: "Comprehensive environmental assessments and sustainability reporting"
    },
    gridCompliance: {
      title: "Grid Compliance",
      description: "Regulatory compliance and grid code adherence consulting"
    },
    financial: {
      title: "Financial Modeling",
      description: "Economic analysis, ROI projections, and investment optimization"
    },
    projectManagement: {
      title: "Project Management",
      description: "End-to-end project delivery from concept to commissioning"
    },
    regulatory: {
      title: "Regulatory Consulting",
      description: "Permitting, licensing, and regulatory strategy development"
    }
  }
};

export const cta = {
  title: "Ready to discuss your next project?",
  button: "Contact Us",
  description: "Partner with SALL Engineering for world-class consulting and engineering services in renewable energy."
};

export const contact = {
  sectionLabel: "GET IN TOUCH",
  sectionTitle: "Let's Discuss Your Project",
  description: "Whether you're planning a new renewable energy installation or need expert consulting for an existing project, our team is ready to help.",
  form: {
    fullName: "Full Name",
    company: "Company",
    email: "Email",
    phone: "Phone",
    serviceInterest: "Service Interest",
    projectDetails: "Project Details",
    required: "*",
    maxCharacters: "Maximum 500 characters",
    submit: "Submit Inquiry",
    placeholders: {
      fullName: "John Smith",
      company: "Your Company",
      email: "john@company.com",
      phone: "+1 (555) 123-4567",
      projectDetails: "Tell us about your project requirements, timeline, and any specific challenges you're facing..."
    },
    serviceOptions: {
      select: "Select a service",
      solar: "Solar Energy Systems",
      wind: "Wind Power Solutions",
      battery: "Battery Storage",
      grid: "Grid Integration",
      general: "General Consulting"
    },
    status: {
      sending: "Sending...",
      success: "Thank you! We will contact you soon.",
      error: "Something went wrong. Please try again.",
      networkError: "Network error. Please try again.",
      maxLength: "Project details must be 500 characters or less"
    }
  }
};

export const footer = {
  quickLinks: "Quick Links",
  contactTitle: "Contact",
  email: "info@sallengineering.com",
  copyright: "© 2025 SALL Engineering. All rights reserved.",
  privacy: "Privacy Policy",
  terms: "Terms of Service"
};
